import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useToasts } from 'react-toast-notifications';
import TextAreaAutosize from 'react-textarea-autosize';
import H1 from 'components/H1';
import H2 from 'components/H2';
import { Flex, Box, Button } from 'rebass';
import { Input, Label, Textarea, Switch } from '@rebass/forms';
import {
    FiLink,
    FiCopy,
    FiChevronDown,
    FiXCircle,
    FiExternalLink,
    FiFileText,
    FiType,
    FiSettings,
    FiArrowUp
} from 'react-icons/fi';
import people_service from 'services/people';
import services from 'services/services';
import helpers from 'utils/helpers';
import helpersScreener from 'utils/helpers-screener';
import config from 'config';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment-timezone';
import EventEmitter from 'utils/events';

import { HeaderSubnavButton } from 'components/Header/HeaderSubnavButton';
import NiceDropdown from 'components/NiceDropdown';
import BreadcrumbDivider from 'components/Breadcrumb/BreadcrumbDivider';
import AppPageWrapper from 'components/AppPageWrapper';
import AppPageSubnav from 'components/AppPageWrapper/AppPageSubnav';
import AppPageBreadcrumbs from 'components/AppPageWrapper/AppPageBreadcrumbs';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import ParticipantsPageSubNav from 'containers/ParticipantsPage/ParticipantsPageSubNav';
import ListWrapper from 'components/ListWrapper';
import ItemWrapper from 'components/ItemWrapper';
import { ReactFormBuilder } from 'components/ReactFormBuilder';
import ReactFormBuilder_store from 'components/ReactFormBuilder/stores/store';
import ScreenerTranslationComponent from 'components/ScreenerTranslationComponent';
import { CollapsibleContentContainer } from 'components/CollapsibleContent';

import LoadingIndicator from 'components/LoadingIndicator';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';

let saveDelay;
let saveDelay_translation;

function PanelSignupPage(props) {
    const tab_screener_builder = 'screener-builder';
    const tab_screener_configuration = 'screener-configuration';
    const tab_screener_redirect = 'screener-redirect';
    const page_tabs = [
        { title: 'Form Builder', label: tab_screener_builder, icon: <FiFileText /> },
        { title: 'Redirects & Language', label: tab_screener_redirect, icon: <FiType /> },
        { title: 'Form Settings', label: tab_screener_configuration, icon: <FiSettings /> }
    ];

    const [pageTabSelected, setPageTabSelected] = useState(tab_screener_builder);
    const [panelFormData, setPanelFormData] = useState({});
    const [screenerTranslation, setScreenerTranslation] = useState([]);
    const [stLoading, setStLoading] = useState(false);

    const { addToast } = useToasts();

    const { pathname, hash } = useLocation();
    const history = useHistory();

    useEffect(() => {
        const tabLabel = hash.replace('#', '');
        if (page_tabs.filter(tab => tab.label === tabLabel).length > 0) {
            setPageTabSelected(tabLabel || page_tabs[0].label);
        }
    }, [pathname, hash]);

    useEffect(() => {
        xhrGetScreenerTranslation();
        xhrGetForm();

        const that = this;
        EventEmitter.subscribe('screener.save.success', screenerObject => {
            emitUpdatedFormSaveUrl(screenerObject);
        });
        EventEmitter.subscribe('screener.save.error', error => {
            const errorText = services.parseXhrErrors(error);

            addToast(errorText, {
                appearance: 'error',
                autoDismiss: false
            });
        });

    }, []);

    function xhrGetForm() {
        people_service
            .getPanelSignupForm(props.match.params.panel_form_id)
            .then(sf => {
                setPanelFormData(sf);
                ReactFormBuilder_store.dispatch('updateOrder', { elements: sf.form, saveData: false });
                emitUpdatedFormSaveUrl(sf);
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);
                console.log(error);

                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    function emitUpdatedFormSaveUrl(screenerObject) {
        const new_url = getScreenerFormSaveUrl(screenerObject);
        console.log('emitting new url', new_url);
        ReactFormBuilder_store.dispatch('updateSaveUrl', new_url);
    }

    function getScreenerFormSaveUrl(screener) {
        return `/panel-signup-forms/${props.match.params.panel_form_id}/screener?account_id=${props.auth.account.id}&form_updated_at=${screener.form_updated_at}`;
    }

    function xhrGetScreenerTranslation() {
        setStLoading(true);
        people_service
            .getScreenerTranslation(props.match.params.panel_form_id)
            .then(st => {
                setScreenerTranslation(st);
                setStLoading(false);
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);
                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });

                setStLoading(false);
            });
    }

    function xhrUpdateScreenerTranslation(st) {
        people_service
            .updateScreenerTranslation(props.match.params.panel_form_id, st)
            .then(() => {
                console.log('calling toast');
                addToast('Form saved', {
                    appearance: 'success',
                    autoDismiss: true
                });
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    function xhrUpdatePanelForm(pf) {
        people_service
            .updatePanelForm(pf)
            .then(() => {
                console.log('I am calling');
                addToast('Form saved', {
                    appearance: 'success',
                    autoDismiss: true
                });
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    function handleTranslationChange(e) {
        let st = cloneDeep(screenerTranslation);
        st[e.target.name] = e.target.value;
        setScreenerTranslation(st);

        // detect change, and clear timeout if exists
        if (saveDelay_translation) {
            clearTimeout(saveDelay_translation);
        }

        saveDelay_translation = setTimeout(() => {
            xhrUpdateScreenerTranslation(st);
        }, 500);
    }

    function onFormChange(e) {
        const { name, value } = e.target;
        const newState = cloneDeep(panelFormData);

        if (name === 'custom_js') {
            newState[name] = [{ when: '', execute: value }];
        } else {
            newState[name] = value;
        }

        // console.log(name, value);
        setPanelFormData(newState);

        // detect change, and clear timeout if exists
        if (saveDelay) {
            clearTimeout(saveDelay);
        }

        saveDelay = setTimeout(() => {
            xhrUpdatePanelForm(newState);
        }, 500);
    }

    function removeCustomLink() {
        const isConfirmed = confirm(
            'Are you sure you want to permanently delete this link? If you shared this link with anyone, they will no longer be able to access it.'
        );
        if (isConfirmed) {
            services
                .deletePanelSignupCustomLink(panelFormData.id)
                .then(custom_links => {
                    let pfd = panelFormData;
                    pfd.links = custom_links;
                    setPanelFormData(pfd);

                    addToast('Removed custom link', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                })
                .catch(error => {
                    const errorText = services.parseXhrErrors(error);
                    console.log(error);
                    addToast(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        } else {
            console.log('not deleting');
        }
    }

    function setCustomLink() {
        const newLink = prompt('What would you like the link to be?');
        if (newLink) {
            services
                .setPanelSignupCustomLink(panelFormData.id, newLink)
                .then(custom_links => {
                    let pfd = panelFormData;
                    pfd.links = custom_links;
                    setPanelFormData(pfd);

                    addToast('Added custom link', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                })
                .catch(error => {
                    const errorText = services.parseXhrErrors(error);
                    console.log(error);
                    addToast(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        }
    }

    let publicPanelProfileUrl = helpersScreener.getPanelSignupLink(
        props.auth.account,
        panelFormData.links,
        props.match.params.panel_form_id
    );

    return (
        <Flex style={{ width: '100%' }}>
            <AppPageWrapper>
                <Helmet>
                    <title>Signup Form</title>
                </Helmet>

                <AppPageSubnav>
                    <Flex width="100%" justifyContent="space-between">
                        <Box width="100%">
                            <Box>
                                <AppPageBreadcrumbs
                                    items={[
                                        { url: `/panel`, title: `Panel` },
                                        { url: `/panel-signup`, title: `Panelist Sign-up` },
                                        { url: null, title: panelFormData.title }
                                    ]}
                                ></AppPageBreadcrumbs>
                            </Box>
                        </Box>
                    </Flex>
                </AppPageSubnav>
                <Flex sx={{ flexDirection: 'row', border: 0 }} px={4} className="tertiary-nav">{/*tertiary-nav-padded*/}
                    {page_tabs.map(pt => {
                        return (
                            <HeaderSubnavButton
                                //style={{ padding: '0 0 8px 0' }}
                                className={pageTabSelected == pt.label && 'active'}
                                onClick={() => history.push(`#${pt.label}`)}
                            >
                                <div className="subnav-primary">
                                    {pt.icon}
                                    {pt.title}
                                </div>
                            </HeaderSubnavButton>
                        );
                    })}
                </Flex>
                <AppPageWrapperSectionBody
                    style={{ background: pageTabSelected == tab_screener_builder ? '#f6f6f6' : '#fff' }}
                >
                    <Box mx={4} my={3} width="100%">
                        {pageTabSelected == tab_screener_configuration && (
                            <>
                                <Box className="form-wrapper2 form-wrapper2-border">
                                    <Box className="settings-header">
                                        <H2>Basic Details</H2>
                                        <Box className="form-section-information">
                                            Information about the panel signup form.
                                        </Box>
                                    </Box>
                                    <Box className="form-data">
                                        <Box className="form-label">Public Title</Box>
                                        <Box>
                                            <Input
                                                type="text"
                                                name="title"
                                                value={panelFormData.title ? panelFormData.title : ''}
                                                onChange={onFormChange}
                                            />
                                        </Box>
                                        <Box className="form-label form-row-margin">Public Description</Box>
                                        <Box>
                                            <Textarea
                                                name="description"
                                                value={panelFormData.description ? panelFormData.description : ''}
                                                onChange={onFormChange}
                                            />
                                        </Box>

                                        <Box className="form-label form-row-margin">Public Link</Box>
                                        <Box>
                                            <Flex
                                                fontSize={1}
                                                mb={1}
                                                sx={{ width: '100%' }}
                                                className="mimic-theme rounded"
                                            >
                                                <Box p={2} sx={{ borderRight: '1px solid #eee', flexShrink: 0 }}>
                                                    <FiLink
                                                        style={{ margin: '9px 8px 7px', fontSize: '16px', color: '#777' }}
                                                    />
                                                </Box>

                                                <Box
                                                    className="ellipsis quiet"
                                                    sx={{ padding: '14px 16px 12px', flexGrow: 1 }}
                                                >
                                                    <a href={publicPanelProfileUrl} target="_blank" className="quiet">
                                                        {publicPanelProfileUrl}
                                                    </a>
                                                </Box>

                                                <Box p={2} sx={{ flexShrink: 0 }}>
                                                    <Button
                                                        variant="primary"
                                                        mr={0}
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            helpers.copyToClipboard(publicPanelProfileUrl);
                                                            addToast('Copied link', {
                                                                appearance: 'success',
                                                                autoDismiss: true
                                                            });
                                                        }}
                                                    >
                                                        <FiCopy /> Copy
                                                    </Button>
                                                </Box>
                                            </Flex>

                                            <Box>
                                                {panelFormData && panelFormData.links && panelFormData.links.length > 0 ? (
                                                    <Button
                                                        variant="link"
                                                        fontSize={1}
                                                        className="quiet"
                                                        onClick={removeCustomLink}
                                                    >
                                                        <u>Remove custom link "{panelFormData.links[0].slug}"</u>
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant="link"
                                                        fontSize={1}
                                                        className="quiet"
                                                        onClick={setCustomLink}
                                                    >
                                                        <u>Create custom link</u>
                                                    </Button>
                                                )}
                                                {helpers.newFeatureTag(moment('11-21-2021', 'MM-DD-YYYY'), {
                                                    margin: '7px 0 0 8px'
                                                })}
                                            </Box>
                                        </Box>
                                        <Box className="form-label form-row-margin">Show In Profile</Box>
                                        <Box>
                                            <Switch
                                                mt={2}
                                                className="switch-small"
                                                name="show_in_profile"
                                                checked={panelFormData.show_in_profile ? true : false}
                                                onClick={e => {
                                                    onFormChange({
                                                        target: {
                                                            name: 'show_in_profile',
                                                            value: !panelFormData.show_in_profile
                                                        }
                                                    });
                                                }}
                                            />
                                            <Label className="quiet">
                                                Choose whether or not this form should show up on all logged in panelist
                                                profiles.
                                            </Label>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box className="form-wrapper2 form-wrapper2-border">
                                    <Box className="settings-header">
                                        <H2>Custom Javascript</H2>
                                        <Box className="form-section-information">
                                            Define custom javascript that will be executed on the singup form page.
                                        </Box>
                                    </Box>
                                    <Box className="form-data">
                                        <Box className="form-label">Javascript code</Box>
                                        <Box>
                                            <TextAreaAutosize
                                                name="custom_js"
                                                value={
                                                    panelFormData.custom_js ? panelFormData.custom_js[0].execute : ''
                                                }
                                                onChange={onFormChange}
                                                width="100%"
                                                minRows={3}
                                                className="theme-input"
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                        )}
                        {pageTabSelected == tab_screener_builder && (
                            <Box>
                                {panelFormData.form ? (
                                    <Box sx={{ position: 'relative' }}>
                                        <ReactFormBuilder
                                            data={panelFormData.form}
                                            page_logic={panelFormData.page_logic}
                                            saveUrl={getScreenerFormSaveUrl(panelFormData)}
                                            read_only={1}
                                            screener_for="panel"
                                        />
                                        <Button
                                            variant="circle"
                                            sx={{ position: 'fixed', bottom: '32px', right: '32px' }}
                                            onClick={e => {
                                                helpers.scrollToTop();
                                            }}
                                        >
                                            <FiArrowUp style={{ fontSize: '29px', strokeWidth: '1px' }} />
                                        </Button>
                                    </Box>
                                ) : (
                                    <div>
                                        <LoadingWrapper>
                                            <LoadingIndicator />
                                        </LoadingWrapper>
                                        <br />
                                    </div>
                                )}
                            </Box>
                        )}

                        {pageTabSelected == tab_screener_redirect && (
                            <Flex mb={3} className="form-wrapper2 form-wrapper2-border">
                                {stLoading ? (
                                    <LoadingWrapper>
                                        <LoadingIndicator />
                                    </LoadingWrapper>
                                ) : (
                                    <ScreenerTranslationComponent
                                        screener_translation={screenerTranslation}
                                        handleTranslationChange={handleTranslationChange}
                                    />
                                )}
                            </Flex>
                        )}
                    </Box>
                </AppPageWrapperSectionBody>
            </AppPageWrapper>
        </Flex>
    );
}

export default PanelSignupPage;
